import { BackButton } from "@/components/shared";
import { LeisureMark } from "@/components/marks";
import { images } from "@/lib/constants";

export function GalleryPage() {
  return (
    <div className="pt-40 pb-24 px-6 md:px-12 max-w-7xl mx-auto animate-in fade-in duration-700">
      <div className="flex flex-col md:flex-row justify-between items-end mb-16 border-b border-[#293129] pb-6">
        <div>
          <BackButton />
          <h1 className="font-serif text-5xl md:text-7xl uppercase">The Compound</h1>
        </div>
        <p className="tracking-widest uppercase text-xs font-bold opacity-60 mt-4 md:mt-0">Visual Archives • Vol I</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 auto-rows-[250px]">
        <div className="md:col-span-2 md:row-span-2 relative arch-crop overflow-hidden group">
          <img src={images.desert} alt="Desert" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000 text-transparent" />
        </div>
        <div className="bg-[#C06B5D] p-8 flex flex-col items-center justify-center text-center">
          <LeisureMark className="w-24 h-24 text-[#ECE9E0] opacity-80" />
        </div>
        <div className="relative overflow-hidden arch-crop border border-[#293129]/20">
          <img src={images.lounge} alt="Lounge" className="w-full h-full object-cover text-transparent" />
        </div>
        <div className="md:row-span-2 relative overflow-hidden">
          <img src={images.sauna} alt="Sauna" className="w-full h-full object-cover text-transparent" />
        </div>
        <div className="bg-[#1D4C74] p-8 flex flex-col justify-end text-[#ECE9E0]">
          <p className="font-serif text-3xl italic">Yves Klein Blue.</p>
        </div>
        <div className="md:col-span-2 relative overflow-hidden rounded-br-[100px]">
          <img src={images.tiles} alt="Mosaics" className="w-full h-full object-cover text-transparent" />
        </div>
      </div>
    </div>
  );
}
